import type { SchoolResponse } from '@shared/schemas';

import api from '@/shared/api/api-client';

import { toServerPage } from '../domain/pagination';
import type { SchoolQueryGateway } from './school-query';

/**
 * Real implementation of the shared school-read query, parameterised by endpoint.
 * The admin and client Schools lists have the same request/response shape but hit
 * different backend routes (`/admin/schools`, every licence, admin-guarded, vs
 * `/schools`, the caller's own licence, scoped server-side), so each slice binds
 * this factory to its path. `getRaw` preserves the `{ data, pagination }` envelope
 * so we can read the grand total. Paging is 1:1 with the original `useInfiniteApi`.
 */
export function makeSchoolQueryHttp(path: string): SchoolQueryGateway {
  return {
    fetchSchools: async ({ page, pageSize }) => {
      const res = await api.getRaw<SchoolResponse[]>(
        `${path}?page=${toServerPage(page)}&limit=${pageSize}`,
      );
      const rows = res.data ?? [];
      return { rows, total: res.pagination?.total ?? rows.length };
    },
  };
}
